import { ContactPage } from '@/app/pages/ContactPage';

export function ResponsiveContactPage() {
  return <ContactPage />;
}
